define('models/StoreServiceModel',['underscore','ObjectModel','LocalStorage'],function (_,ObjectModel,LocalStorage) {
    //
    // Model Store Service
    //
    var StoreServiceModelPrototype = {

        name:'StoreServiceModel',
        idAttribute:'id_store_service',
        route:'apiStoreServiceModel',
        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
        }
    };

    var StoreServiceModel = ObjectModel.extend(LocalStorage).extend(StoreServiceModelPrototype);

    return StoreServiceModel;
});
